import { initJcFirebase } from 'jcfirebase';

// Emulators: opt in with REACT_APP_USE_EMULATORS=true (`npm run local:jcallard`).
initJcFirebase({
    apiKey: "AIzaSyC45Hox_rkTI5bzUNgJRuIHrk41pUOxeNU",
    authDomain: "jcallard-4c495.firebaseapp.com",
    projectId: "jcallard-4c495",
    storageBucket: "jcallard-4c495.appspot.com",
    messagingSenderId: "477917152172",
    appId: "1:477917152172:web:6c170bb315abf3cd0ff009",
    measurementId: "G-J2P4779CBH",
}, {
    useEmulators: process.env.REACT_APP_USE_EMULATORS === "true",
    // Offset from hoops' ports (firebase.json) so both suites can run at once.
    emulatorPorts: { auth: 9098, firestore: 8081, storage: 9198, functions: 5002 },
});
